<template>
  <div class="new-project-details">
    <div class="details-name">
      <v-text-field
        type="text"
        maxlength="50"
        v-model="detailsData.name"
        :placeholder="$t('newProject.program.title')"
        :error-messages="errorMessages"
      />
    </div>
    <div class="test-type-section">
      <div class="type-section web-app-test active" @click="selectWebAppTestType">
        <div class="image"><img src="../../assets/icons/web_app_active_icn@1x.svg" /></div>
        <div class="text">{{ $t('newProject.web.ppp.penetration.test') }}</div>
      </div>
      <div class="type-section infrastructure-test" @click="false && selectInfrastructureTestType">
        <div class="image"><img src="../../assets/icons/Infrastructure_inactive_icn@1x.svg" /></div>
        <div class="text">{{ $t('newProject.infrastructure.penetration.test') }}</div>
        <coming-soon class="type-section-coming-soon" />
      </div>
    </div>
    <div class="project-manager-section">
      <label class="label-section-title">{{ $t('newProject.project.manager') }}</label>
      <div class="project-manager-selection details-data-section">
        <div class="radio-section small">
          <div class="radio-section-row">
            <input
              type="radio"
              checked="checked"
              name="radio"
              :value="MT.ME"
              v-model="detailsData.managerType"
              v-on:change="manageTypeChanged"
            />
            <label>{{ $t('newProject.i.will.manage') }}</label>
          </div>
        </div>
        <div class="radio-section">
          <div class="radio-section-row">
            <input
              type="radio"
              name="radio"
              :value="MT.OTHER"
              v-model="detailsData.managerType"
              v-on:change="manageTypeChanged"
            />
            <label>
              {{ $t('newProject.my.team.member.will.manage') }}
            </label>
          </div>
          <v-autocomplete
            :items="managers"
            class="select-manager"
            :class="{ active: teamMemberWillManage }"
            v-model="detailsData.manager"
            return-object
            :disabled="!teamMemberWillManage"
            item-text="name"
            dense
            outlined
            :placeholder="$t('newProject.select.manager')"
          >
          </v-autocomplete>
        </div>

        <div class="radio-section">
          <div class="radio-section-row">
            <input type="radio" name="radio" value="false" disabled />
            <label class="inactive">{{ $t('newProject.new.user.will.manage.the.project') }}</label>
          </div>
          <coming-soon class="new-user-manager-coming-soon" />
        </div>
      </div>
    </div>
    <div class="additional-comment-section">
      <label class="label-section-title">
        {{ $t('newProject.additional.comment') }}
      </label>
      <div class="details-data-section text-area-container">
        <textarea
          v-model="detailsData.comment"
          maxlength="500"
          :placeholder="$t('newProject.enter.your.additional.comments')"
          class="form-control"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ComingSoon from '@/components/common/ComingSoon.vue';

import { managerTypes, testTypes } from '@/constants/projects';

export default {
  name: 'NewProjectDetails',
  components: {
    ComingSoon,
  },
  props: {
    newProject: {
      type: Object,
      required: true,
    },
    managers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      MT: managerTypes,
      detailsData: this.newProject.projectDetailsData,
    };
  },
  computed: {
    ...mapGetters(['profile']),
    teamMemberWillManage() {
      return this.detailsData.managerType === this.MT.OTHER;
    },
    errorMessages() {
      if (!this.detailsData.name) {
        return this.$t('newProject.program.title.empty');
      }

      return [];
    },
  },
  beforeMount() {
    this.detailsData.name = 'Web Test 1';
  },
  watch: {
    newProject: {
      deep: true,
      handler() {
        this.$emit('setRequiredDataForStep', 1);
      },
    },
    'newProject.projectDetailsData.manager': {
      handler() {
        this.$emit('setRequiredDataForStep', 1, true);
      },
    },
  },
  methods: {
    notEmpty(value) {
      return !!value && !!value.length;
    },
    selectWebAppTestType() {
      this.detailsData.testType = testTypes.WEB_APP_TEST;
    },
    selectInfrastructureTestType() {
      this.detailsData.testType = testTypes.INFRASTRUCTURE_TEST;
    },
    manageTypeChanged() {
      if (this.detailsData.managerType === managerTypes.ME) {
        this.detailsData.manager = this.profile;
      } else {
        this.detailsData.manager = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

#app .v-text-field {
  &.select-manager {
    margin-top: $space-4;
  }
}

.select-manager {
  &.active {
    .v-input__control {
      .v-input__slot {
        fieldset {
          border-color: var(--brand-primary) !important;
        }
      }
    }
  }
}
.details-name {
  margin: auto;
  padding: 0 rem(52);

  .v-input {
    width: 100%;
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(24);
    letter-spacing: 0;
    line-height: rem(29);
    bottom: rem(15);
    position: relative;

    .v-input__control {
      .v-input__slot {
        padding-bottom: $space-2;

        ::before {
          border: none;
          border-bottom: 1px solid var(--border-primary);
        }
      }
    }
  }

  .v-input:focus {
    outline: none;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.new-project-details {
  padding: rem(40) rem(100) rem(32);
}

.coming-soon {
  color: var(--status-warning);
  align-self: center;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: rem(16);
  padding: rem(2.5) rem(8.5);
  border-radius: $radius-sm;
  border: 1px solid var(--status-warning);

  &.new-user-manager-coming-soon {
    margin-top: rem(20);
  }

  &.type-section-coming-soon {
    margin-top: $space-2;
  }
}

.test-type-section {
  text-align: center;
  margin-bottom: $space-4;
  display: flex;
  justify-content: center;
  align-items: center;

  .test-types-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .type-section {
    display: inline-block;
    width: rem(288);
    padding: rem(42) rem(60) rem(36);

    margin: $space-2;

    &.infrastructure-test {
      padding: rem(42) rem(60) rem(28);
    }

    &.active {
      width: rem(288);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: 0 0 rem(20) 0 rgba(12, 18, 62, 0.08);
      cursor: pointer;

      .text {
        color: var(--text-primary);
      }
    }

    .image {
      text-align: center;
      height: rem(100);
    }

    .text {
      color: var(--text-secondary);
      margin-top: rem(33);
      font-family: $font-family-regular;
      font-size: rem(20);
      letter-spacing: 0;
      line-height: rem(23);
      text-align: center;
    }
  }
}

.details-data-section {
  border-radius: $radius-sm;
  background-color: var(--bg-primary);
  box-shadow: 0 0 $space-2 0 rgba(12, 18, 62, 0.08);
  margin-top: $space-1;
}

.project-manager-section {
  .project-manager-selection {
    display: flex;
    padding: rem(24) rem(32);

    .radio-section {
      display: flex;
      align-items: center;
      flex-direction: column;

      flex: 1;

      &.small {
        flex: 0.5;
      }

      .radio-section-row {
        display: flex;
      }

      label {
        color: var(--text-primary);
        font-size: $font-size-base;
        letter-spacing: 0;
        line-height: rem(16);
        vertical-align: super;
      }

      input {
        width: rem(20);
        height: rem(20);
        margin-right: $space-2;
      }

      .select-manager {
        height: rem(32);
        width: rem(167);
        align-self: center;

        border-radius: $radius-sm;
        box-sizing: border-box;
        background-color: var(--bg-primary);

        &.active {
          .v-select__slot {
            border-color: var(--status-error);
          }
        }
      }
    }
  }
}

.label-select-manager-title {
  left: rem(-61);
  top: rem(-20);
}

.inactive {
  color: var(--text-secondary) !important;
}

.label-section-title {
  height: rem(10);
  width: rem(103);
  color: var(--text-secondary);
  font-size: $font-size-xs;
  letter-spacing: 0.8px;
  line-height: rem(10);
  text-transform: uppercase;
}

.additional-comment-section {
  margin-top: rem(40);

  textarea {
    width: 100%;
    height: 100%;
    resize: none;
    padding: $space-2 $space-2 $space-2 $space-3;

    &:focus {
      outline: none;
      border: 1px solid var(--text-secondary);
      box-shadow: 0 0 $space-2 var(--brand-primary);
    }
  }
}
</style>
